import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getAndroidGeneratedInput } from 'api';

// Then, handle actions in your reducers:
const androidGeneratedInputSlice = createSlice({
  name: 'androidGeneratedInput',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    androidGeneratedInputFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    androidGeneratedInputFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    androidGeneratedInputFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    androidGeneratedInputResetState: (state) => {
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  androidGeneratedInputFetchStart,
  androidGeneratedInputFetchSuccess,
  androidGeneratedInputFetchFail,
  androidGeneratedInputResetState,
} = androidGeneratedInputSlice.actions;

// The reducer
export const androidGeneratedInputReducer = androidGeneratedInputSlice.reducer;

// Asynchronous thunk action
export const androidGeneratedInputFetch = (data: Object) => (dispatch) => {
  dispatch(androidGeneratedInputFetchStart());

  getAndroidGeneratedInput(data)
    .then((androidGeneratedInput) => {
      dispatch(androidGeneratedInputFetchSuccess(androidGeneratedInput.data));
    })
    .catch((error) => {
      dispatch(androidGeneratedInputFetchFail(error));
    });
};
